import tippy from "tippy.js";

const contactInfoItems = document.querySelectorAll(".js-contact-info-item");

if (contactInfoItems) {
    window.addEventListener("load", () => initContactItemsTooltips(contactInfoItems));
}

function initContactItemsTooltips(tooltipTargets) {
    const readyToInitItems = [];

    for (const item of tooltipTargets) {
        if (item.hasAttribute("data-announcing")) {
            readyToInitItems.push(item);
        }
    }

    tippy(readyToInitItems, {
        arrow: true,
        theme: "light",
        placement: "bottom",
        ignoreAttributes: true,
        trigger: "mouseenter click",
        hideOnClick: true,
        allowHTML: true,
        onCreate(instance) {
            instance.setContent(instance.reference.dataset.announcing);
            instance.reference.removeAttribute("data-announcing");
        },
    });
}
